import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import BaiduMap from 'vue-baidu-map'
import {BmlMarkerClusterer} from 'vue-baidu-map';
import VueElementLoading from "vue-element-loading"

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.component("VueElementLoading", VueElementLoading)

Vue.use(BaiduMap, {
  ak: 'gYmchN5ezbzWYKz3AGD8WT1rPwfg1G4p'
})

new Vue({
  render: h => h(App),
  router,
  store,
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
